import React, { useState } from "react";
import { Box, Container, Grid, Typography, Button } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";

const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0";

const IMG_SOURCES = [
  "/showcase-sec/classroom-learning.png",
  "/showcase-sec/art-activity.png",
  "/showcase-sec/faculty-guidance.png",
];

const ShowcaseSection = ({ slides, onNavigate }) => {
  const [active, setActive] = useState(0);
  const slide = slides[active] || slides[0];

  return (
    <AnimatedSection sx={{ backgroundColor: CORAL, py: { xs: 9, md: 12 } }}>
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Box sx={{ display: "inline-block", px: 2, py: 0.5, mb: 2, borderRadius: "8px", border: `2px solid ${NAVY}`, backgroundColor: YELLOW, fontFamily: "'Space Grotesk', sans-serif", fontWeight: 800, fontSize: "0.78rem", letterSpacing: "0.1em", color: NAVY, textTransform: "uppercase" }}>
            School Moments
          </Box>
          <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: { xs: "2rem", md: "2.8rem" }, color: "#fff", lineHeight: 1.15 }}>
            Life at St Lord's 📸
          </Typography>
        </Box>

        <Grid container spacing={4} alignItems="center">
          {/* Tabs */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              {slides.map((s, i) => (
                <Box
                  key={i}
                  onClick={() => setActive(i)}
                  sx={{
                    p: 2.5, borderRadius: "14px", cursor: "pointer",
                    border: `2.5px solid ${NAVY}`,
                    backgroundColor: active === i ? NAVY : "#fff",
                    boxShadow: `4px 4px 0 ${NAVY}`,
                    transition: "all 0.2s ease",
                    "&:hover": { transform: "translate(-2px,-2px)", boxShadow: `6px 6px 0 ${NAVY}` },
                  }}
                >
                  <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.1rem", color: active === i ? YELLOW : NAVY, mb: 0.5 }}>
                    {["🏫", "🎨", "💻"][i]} {s.title}
                  </Typography>
                  {active === i && (
                    <Typography sx={{ color: "rgba(255,248,240,0.8)", fontWeight: 600, fontSize: "0.85rem", lineHeight: 1.6 }}>
                      {s.caption}
                    </Typography>
                  )}
                </Box>
              ))}

              <Button
                variant="contained"
                onClick={() => onNavigate("gallery")}
                sx={{ mt: 1, backgroundColor: YELLOW, color: NAVY, border: `2.5px solid ${NAVY}`, boxShadow: `4px 4px 0 ${NAVY}`, "&:hover": { backgroundColor: "#FFE566" } }}
              >
                See Full Gallery →
              </Button>
            </Box>
          </Grid>

          {/* Image */}
          <Grid item xs={12} md={8}>
            <Box sx={{ borderRadius: "20px", border: `3px solid ${NAVY}`, boxShadow: `8px 8px 0 ${NAVY}`, overflow: "hidden", backgroundColor: "#fff", aspectRatio: "16/9", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box
                component="img"
                src={IMG_SOURCES[active]}
                alt={slide.title}
                key={active}
                sx={{ width: "100%", height: "100%", objectFit: "cover", animation: "pop 0.4s ease-out both" }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AnimatedSection>
  );
};

export default ShowcaseSection;
